import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();

export default {
  async getProviders() {
    try {
      getUxStore().startLoading();
      return await apiClient.get("/admin/identity-providers");
    } catch (error) {
      console.error("Error in AdminIdentityProviderService.getProviders:", error);
      getUxStore().setError("Fehler beim Laden der Identity Provider.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getCallbackUrls() {
    try {
      getUxStore().startLoading();
      return await apiClient.get("/admin/identity-providers/callback-urls");
    } catch (error) {
      console.error("Error in AdminIdentityProviderService.getCallbackUrls:", error);
      getUxStore().setError("Fehler beim Laden der Callback-URLs.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async upsertProvider(payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.put("/admin/identity-providers", payload);
    } catch (error) {
      console.error("Error in AdminIdentityProviderService.upsertProvider:", error);
      getUxStore().setError("Fehler beim Speichern des Identity Providers.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async deleteProvider(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.delete(`/admin/identity-providers/${id}`);
    } catch (error) {
      console.error("Error in AdminIdentityProviderService.deleteProvider:", error);
      getUxStore().setError("Fehler beim Löschen des Identity Providers.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
